import script from "./VerificationRecorderView.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerificationRecorderView.vue?vue&type=script&setup=true&lang=ts"

import "./VerificationRecorderView.vue?vue&type=style&index=0&id=becd1c38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-becd1c38"]])

export default __exports__